<template>
  <section>
    <div class="a4-container" id="diplomaPage1" v-if="student">
      <!-- <span style="position: absolute; right: 400px; top: 100px !important"
      >D2029220420</span
    > -->
      <div style="text-align: center; font-size: 16pt; margin-top: 200px">
        Монгол Улсын иргэн
        <strong style="text-transform: uppercase">{{
          student.lastName
        }}</strong>
        овогтой
        <strong style="text-transform: uppercase">{{
          student.firstName
        }}</strong>
        нь
      </div>
      <div style="text-align: center; font-size: 16pt; margin-top: 120px">
        <p
          style="margin-top: 0px !important; margin-bottom: 0px !important"
          v-if="student.profession"
        >
          ТЕХНИК ТЕХНОЛОГИЙН ДЭЭД СУРГУУЛЬ-д
          <strong
            ><span class="blue--text">{{
              student.profession.xcurriculumIndex
            }}</span></strong
          >
          хөтөлбөр (<span class="blue--text">{{
            student.profession.xcurriculumIndex
          }}</span
          >)-өөр
        </p>
        <p style="margin-top: 0px !important; margin-bottom: 0px !important">
          2019 оноос 2022 онд суралцаж
          <strong
            class="red--text"
            style="text-transform: uppercase"
            v-if="student.profession"
            >{{ student.profession.name }}</strong
          >
          мэргэжлээр төгссөн тул
        </p>
        <p style="margin-top: 0px !important; margin-bottom: 0px !important">
          төгсөлтийн шалгалтын комиссын 2022 оны 01 дүгээр сарын 17-ны өдрийн
        </p>
        <p style="margin-top: 0px !important; margin-bottom: 0px !important">
          2022/02 тоот шийдвэрийг үндэслэн, захирлын 2022 оны 01 дүгээр сарын
          24-ний
        </p>
        <p style="margin-top: 0px !important; margin-bottom: 0px !important">
          өдрийн 17 тоот тушаалаар
          <strong
            v-if="student.profession && student.profession.xprofessiondegree"
            class="red--text"
            style="text-transform: uppercase"
            ><span class="blue--text">{{
              student.profession.xcurriculumIndex
            }}</span>
            {{ student.profession.xprofessiondegree.name }}</strong
          >
          -ын зэрэг олгов
        </p>
      </div>
     <v-row justify="center" class="text-center mt-16 pt-10" >
      <v-col>
        <p class="pclass" style="margin: 0;">Теxник теxнологийн дээд сургуулийн</p>
          <p class="pclass" style="margin: 0;">Удирдаx зөвлөлийн дарга</p>
          <p class="pclass" style="margin: 0;">Xүндэт доктор</p>
          <p class="pclass" style="font-weight: bold;margin: 0;">Б.НЭМЭXБАЯР</p>
      </v-col>
      <v-col>
        <p class="pclass" style="margin: 0;">Теxник теxнологийн дээд</p>
        <p class="pclass" style="margin: 0;">сургуулийн захирал</p>
        <p class="pclass" style="text-transform: uppercase; font-weight: bold;margin: 0;">
          Н.Эрдэмтөгс
        </p>
      </v-col>
      <v-col >
        <p class="pclass" style="margin: 0;">Дипломын төсөл xамгаалаx</p>
        <p class="pclass" style="margin: 0;">комиссын дарга</p>
        <p class="pclass" style="margin: 0;">профессор</p>
        <p class="pclass" style="text-transform: uppercase; font-weight: bold;margin: 0;">  
          Ц.БАЯРМАА
        </p>
      </v-col>
     </v-row>
      <span
        style="
          position: absolute;
          right: 50px;
          bottom: 20px !important;
          margin-bottom: 0px !important;
        "
        >Бүртгэлийн дугаар: 2148</span
      >
    </div>
    <v-row justify="center">
      <v-btn @click="_print" color="secondary">Print</v-btn>
    </v-row>
  </section>
</template>
<script>
const fb = require("@/firebaseConfig.js");
export default {
  data() {
    return {
      school: { name: "ldfjklsdjf" },
      FIRST_NAME: "Hello, Vue!",
      LAST_NAME: "XXX",
      student: null,
    };
  },
  props: {
    studentRefPath: {
      required: true,
      type: String,
    },
  },
  created() {
    fb.db
      .doc(this.studentRefPath)
      .get()
      .then((doc) => {
        this.student = doc.data();
        this.student.id = doc.id;
        this.student.ref = doc.ref;
        this.student.profession = null;
        this.student["xClassGroupRef-2022-2023-1"].xprofessionRef
          .get()
          .then((doc) => {
            if (doc.exists) {
              this.student.profession = doc.data();
              console.log(this.student.profession);
            }
          });
      });
  },
  methods: {
    _print() {
      const printableElement = document.getElementById("diplomaPage1");
      if (printableElement) {
        const printWindow = window.open();
        printWindow.document.write(
          "<html><head><title>Print</title></head><body>"
        );
        printWindow.document.write(printableElement.innerHTML);
        printWindow.document.write("</body></html>");
        printWindow.document.close();
        printWindow.print();
        printWindow.close();
      }
    },
  },
};
</script>
<style>
@media print {
  @page {
    size: landscape;
    margin: 0;
  }

  body {
    margin: 0;
  }
}
.a4-container {
  position: relative;
  width: 29.7cm;
  height: 21cm;
  border: 1px solid black;
  margin: 0 auto;
}
.a4-container .main-text {
  display: inline-block;
  justify-content: center;
  align-items: center;
  border: 1px solid black;
  margin: 0 auto;
  box-sizing: border-box;
}

.a4-container .bottom-container {
  position: relative;
  bottom: 100px;
  display: flex;
  justify-content: space-between;
  height: 100px;

  padding-left: 40px;
  padding-right: 40px;
}

.a4-container .bottom-container .signature {
  border-top: 1px solid black;
  padding-top: 4px !important;
  margin-left: 30px;
  margin-right: 30px;
  width: 33%;
}
.signature .pclass {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.a4-container .head-score-page {
  position: relative;
  top: 10px;
  display: flex;
  justify-content: space-between;
  border: 1px solid black;
}

.a4-container .score-main {
  position: relative;
  display: flex;
  justify-content: space-between;
  border: 1px solid red;
}
.a4-container .head-score-page .title-column {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 2px;
  width: 30%;
  height: 80%;
  background-color: lightgray;
}
.a4-container .head-score-page .title-column .column-text {
  text-align: left;
  padding: 2px;
  width: 50%;
  background-color: lightgray;
}
.a4-container .score-main .score-table-column {
  padding: 2px;
  width: 30%;
  height: 80%;
  background-color: lightgray;
}
.a4-container .score-signature-container {
  position: relative;
  display: flex;
  justify-content: space-between;
  border: 1px solid blue;
}
.a4-container .score-signature-container .score-signature {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 40%;
  background-color: lightgray;
}
.bordered-table {
  border-collapse: collapse;
  width: 100%;
}

.bordered-table th,
.bordered-table td {
  border: 1px solid black;
  padding: 8px;
}
.title-column .upper {
  text-transform: uppercase;
  font-weight: bold;
}
</style>